'use strict';

var _ = require('lodash');
var StrategyAllocationAuthAvailActionService = function StrategyAllocationAuthAvailActionService(StrategyAllocationAuthAvailAction, strategyConstants, fcrService) {
  function getClassNames() {
    return fcrService.getClassesFcrSorted();
  }
  function createAction(actionList, className) {
    var action = new StrategyAllocationAuthAvailAction(className);
    actionList.push(action);
  }
  function fillActions(groups, actions) {
    actions.forEach(function (action) {
      if (groups[action.className]) {
        _.extend(action, groups[action.className]);
      }
    });
  }
  function getActionList(groups) {
    var classNames = getClassNames();
    var actionList = [];
    var actionGroupMap = {};
    if (classNames.length > 0) {
      actionList = _.transform(classNames, createAction);
    }
    if (groups) {
      createActionMap(actionGroupMap, groups);
      fillActions(actionGroupMap, actionList);
    }
    return actionList;
  }
  function createActionMap(actionGroupMap, groups) {
    groups.forEach(function (group) {
      var flattenedGroup = flattenGroup(group.conditions);
      var actionMap = group.actions;
      validateHardOverrideType(actionMap);
      validateLinkType(actionMap);
      var className = getFieldValue(flattenedGroup, strategyConstants.ALLOCATION_AUTH_AVAIL.CLASS_NAME_FIELD);
      var action = new StrategyAllocationAuthAvailAction(className, actionMap.allocationType, actionMap.minAllocation, actionMap.maxAllocation, actionMap.hardOverrideMinValue, actionMap.hardOverrideMaxValue, actionMap.authLinkValue, actionMap.minAvailability, actionMap.maxAvailability, actionMap.linkValue);
      actionGroupMap[className] = action;
    });
  }
  function validateHardOverrideType(actionMap) {
    if (!_.isNil(actionMap.hardOverrideType) && actionMap.hardOverrideType === 'AVAIL') {
      actionMap.minAvailability = actionMap.hardOverrideMinValue;
      actionMap.hardOverrideMinValue = '';
      actionMap.maxAvailability = actionMap.hardOverrideMaxValue;
      actionMap.hardOverrideMaxValue = '';
    }
  }
  function validateLinkType(actionMap) {
    if (!_.isNil(actionMap.linkType) && actionMap.linkType === 'AUTH') {
      actionMap.authLinkValue = actionMap.linkValue;
      actionMap.linkValue = '';
    }
  }
  function flattenGroup(conditions) {
    var result = [];
    (function flatten(conditions) {
      if (conditions.children) {
        conditions.children.forEach(function (condition) {
          flatten(condition);
        });
      } else {
        result.push(conditions);
      }
    })(conditions);
    return result;
  }
  function getFieldValue(condition, field) {
    var parsedField = _.find(condition, {
      selector: field
    });
    return parsedField ? parsedField.arguments.shift() : null;
  }
  function validateActions(actionList) {
    var errorMsgs = [];
    actionList.forEach(function (action) {
      if (validateAllocationEntries(action)) {
        errorMsgs.push('Class \'' + action.className + '\' : ' + strategyConstants.ERROR_MESSAGES.ALLOCATION_ERROR_MSG + '\n');
      }
      if (action.allocationType === 'P' && isValidValue(action.minAllocation) && isValidValue(action.maxAllocation) && (!validPercentageValue(action.minAllocation) || !validPercentageValue(action.maxAllocation))) {
        errorMsgs.push('Class \'' + action.className + '\' : ' + strategyConstants.ERROR_MESSAGES.PERCENTAGE_ALLOCATION_ERROR_MSG + '\n');
      }
      if (validateMinMaxAuthAvailValue(action)) {
        errorMsgs.push('Class \'' + action.className + '\' : ' + strategyConstants.ERROR_MESSAGES.MIN_MAX_AUTH_AVAIL_ERROR_MSG + '\n');
      }
      if (validateMinMaxAuthAvailLink(action, 'authLinkValue', 'linkValue')) {
        errorMsgs.push('Class \'' + action.className + '\' : ' + strategyConstants.ERROR_MESSAGES.OVERRIDE_LINK_ERROR_MSG + '\n');
      }
      validateMinMaxEntries(action, errorMsgs);
    });
    return errorMsgs;
  }
  function validateMinMaxEntries(row, errorMsgs) {
    if (isValidValue(row['minAllocation']) && isValidValue(row['maxAllocation']) && row['minAllocation'] > row['maxAllocation']) {
      errorMsgs.push('Class \'' + row.className + '\' : ' + strategyConstants.ERROR_MESSAGES.ALLOCATION_MIN_MAX_ERROR + '\n');
    }
    if (isValidValue(row['hardOverrideMinValue']) && isValidValue(row['hardOverrideMaxValue']) && row['hardOverrideMinValue'] > row['hardOverrideMaxValue']) {
      errorMsgs.push('Class \'' + row.className + '\' : ' + strategyConstants.ERROR_MESSAGES.AUTH_MIN_MAX_ERROR + '\n');
    }
    if (isValidValue(row['minAvailability']) && isValidValue(row['maxAvailability']) && row['minAvailability'] > row['maxAvailability']) {
      errorMsgs.push('Class \'' + row.className + '\' : ' + strategyConstants.ERROR_MESSAGES.AVAIL_MIN_MAX_ERROR + '\n');
    }
  }
  function isValidValue(value) {
    return !_.isNil(value) && value !== '';
  }
  function isValidAllocationType(value) {
    return !_.isNil(value) && value !== '' && value !== '...';
  }
  function validateAllocationEntries(row) {
    if (isValidValue(row['minAllocation'])) {
      return !isValidValue(row['maxAllocation']) || !isValidAllocationType(row['allocationType']);
    }
    if (isValidValue(row['maxAllocation'])) {
      return !isValidValue(row['minAllocation']) || !isValidAllocationType(row['allocationType']);
    }
    if (isValidAllocationType(row['allocationType'])) {
      return !isValidValue(row['minAllocation']) || !isValidValue(row['maxAllocation']);
    }
    return false;
  }
  function validPercentageValue(value) {
    return value >= 0 && value <= 100;
  }
  function validateMinMaxAuthAvailValue(action) {
    return isValidValue(action.hardOverrideMinValue) && isValidValue(action.minAvailability) || isValidValue(action.hardOverrideMaxValue) && isValidValue(action.maxAvailability) || isValidValue(action.hardOverrideMinValue) && isValidValue(action.maxAvailability) || isValidValue(action.hardOverrideMaxValue) && isValidValue(action.minAvailability);
  }
  function validateMinMaxAuthAvailLink(row, firstField, secondField) {
    return isValidValue(row[firstField]) && isValidValue(row[secondField]);
  }
  return {
    getActionList: getActionList,
    validateActions: validateActions
  };
};
StrategyAllocationAuthAvailActionService.$inject = ['StrategyAllocationAuthAvailActionFactory', 'StrategyConstants', 'FcrService'];
module.exports = StrategyAllocationAuthAvailActionService;